import React, { useRef, useEffect } from 'react';

const RadioGroupInput = ({ options, name, onChange, setPreferedMethod, ...props }) => {
  const radioRef = useRef([]);
  const handleOptionChange = (value) => {
    if (onChange) {
      onChange({ target: { name, value } });
    }
  };

  useEffect(() => {
    if (radioRef.current) {
      radioRef.current.forEach((radio) => {
        if (radio.value === props.value) {
          if (name === 'preferredMethodOfContact') {
            setPreferedMethod(radio.value);
          }
        }
      });
    }
  }, [setPreferedMethod, props.value, name]);

  return (
    <div className="radio-group-container">
      {options.map((option, index) => {
        return (
          <label
            key={name + '-' + index}
            className="radio-group w-full"
            onClick={() => handleOptionChange(option.value)}
          >
            <input
              type="radio"
              className="input"
              id={option.value.toLowerCase()}
              name={name}
              value={option.value}
              defaultChecked={props.value === option.value}
              ref={(element) => {
                if (element) radioRef.current[index] = element;
              }}
            />
            <span className="radio-mark"></span>
            <span className="w-[85%]">{option.label}</span>
          </label>
        );
      })}
    </div>
  );
};

export default RadioGroupInput;
